import styled from 'styled-components';

export const ChannelsPage = styled.div`
  margin-top: 60px;
  @media screen and (max-width: 620px) {
    padding: 0 10px;
  }
`;

export const PageHeader = styled.div`
  margin-bottom: 28px;

  h5 {
    font-size: 22px;
    font-family: rebondG-Semi-Bold;
    color: #191919;
    margin: 0 0 4px;
  }

  p {
    font-size: 13px;
    color: #6b7a99;
    margin: 0;
  }
`;

export const JoinCard = styled.div`
  border-radius: 16px;
  padding: 24px 28px;
  background: #fff;
  border: 1px solid #e8ecf4;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;

  h6 {
    font-size: 15px;
    font-family: rebondG-Semi-Bold;
    color: #191919;
    margin: 0 0 4px;
  }

  small {
    font-size: 12px;
    color: #6b7a99;
    display: block;
    margin-bottom: 16px;
  }
`;

export const JoinForm = styled.form`
  display: flex;
  gap: 12px;
  align-items: center;

  @media screen and (max-width: 620px) {
    flex-direction: column;
  }
`;

export const JoinInput = styled.input`
  flex: 1;
  height: 44px;
  border: 1.5px solid #e0e6f4;
  border-radius: 10px;
  padding: 0 16px;
  font-size: 14px;
  color: #191919;
  outline: none;
  transition: border-color 0.15s ease;
  background: #fafbfd;

  &:focus {
    border-color: #2f67d8;
    background: #fff;
  }

  &::placeholder {
    color: #b0bac9;
  }

  @media screen and (max-width: 620px) {
    width: 100%;
  }
`;

export const JoinButton = styled.button`
  height: 44px;
  padding: 0 28px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1a3568 0%, #2f67d8 100%);
  color: #fff;
  border: none;
  font-size: 14px;
  font-family: rebondG-Semi-Bold;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(47, 103, 216, 0.3);
  transition: all 0.18s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(47, 103, 216, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media screen and (max-width: 620px) {
    width: 100%;
  }
`;

export const SectionLabel = styled.h6`
  font-size: 15px;
  font-family: rebondG-Semi-Bold;
  color: #191919;
  margin: 0 0 16px;
`;

export const ChannelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
`;

export const ChannelCard = styled.div`
  border-radius: 18px;
  padding: 24px;
  background: linear-gradient(140deg, #0a1628 0%, #1a3568 40%, #2f67d8 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.12),
    0 8px 24px rgba(0, 0, 0, 0.18),
    0 20px 56px rgba(47, 103, 216, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow:
      0 4px 8px rgba(0, 0, 0, 0.16),
      0 14px 32px rgba(0, 0, 0, 0.24),
      0 28px 64px rgba(47, 103, 216, 0.3);
  }

  &::before {
    content: '';
    position: absolute;
    right: -50px;
    top: -50px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.07) 0%, transparent 70%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: -40px;
    bottom: -50px;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.04) 0%, transparent 70%);
    pointer-events: none;
  }
`;

export const ChannelCardInner = styled.div`
  position: relative;
  z-index: 1;
`;

export const ChannelAvatar = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: rebondG-Bold;
  color: #fff;
  margin-bottom: 14px;
  text-transform: uppercase;
`;

export const ChannelName = styled.h6`
  font-size: 16px;
  font-family: rebondG-Semi-Bold;
  color: #fff;
  margin: 0 0 3px;
`;

export const ChannelLabel = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 20px;
  letter-spacing: 0.3px;
`;

export const LeaveButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 12px;
  font-family: rebondG-Semi-Bold;
  cursor: pointer;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: all 0.18s ease;

  &:hover:not(:disabled) {
    background: rgba(220, 50, 50, 0.35);
    border-color: rgba(220, 80, 80, 0.5);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 40, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 16px;
  overflow-y: auto;

  @media screen and (max-height: 720px) {
    align-items: flex-start;
  }
`;

export const ModalBox = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 32px 28px 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.2s ease;

  @keyframes slideUp {
    from { transform: translateY(16px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }
`;

export const ModalIcon = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(220, 50, 50, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  color: #c0392b;
  font-size: 22px;
`;

export const ModalTitle = styled.h6`
  font-size: 17px;
  font-family: rebondG-Semi-Bold;
  color: #191919;
  text-align: center;
  margin: 0 0 8px;
`;

export const ModalBody = styled.p`
  font-size: 13px;
  color: #6b7a99;
  text-align: center;
  line-height: 1.6;
  margin: 0 0 24px;

  strong {
    color: #191919;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 10px;

  @media screen and (max-width: 420px) {
    flex-direction: column-reverse;
  }
`;

export const ModalCancelBtn = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 10px;
  border: 1.5px solid #e0e6f4;
  background: #fff;
  color: #4a5568;
  font-size: 14px;
  font-family: rebondG-Semi-Bold;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #f5f7fb;
    border-color: #c8d0e0;
  }
`;

export const ModalLeaveBtn = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 10px;
  border: none;
  background: #c0392b;
  color: #fff;
  font-size: 14px;
  font-family: rebondG-Semi-Bold;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.3);

  &:hover:not(:disabled) {
    background: #a93226;
    box-shadow: 0 6px 16px rgba(192, 57, 43, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FormModalBox = styled(ModalBox)`
  max-width: 680px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 24px 28px;

  @media screen and (max-width: 620px) {
    padding: 22px 18px 18px;
  }
`;

export const FormModalIcon = styled(ModalIcon)`
  background: rgba(47, 103, 216, 0.1);
  color: #2f67d8;
  width: 46px;
  height: 46px;
  margin-bottom: 12px;
`;

export const ModalFieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 14px;

  @media screen and (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const ModalFormGroup = styled.div`
  grid-column: ${({ $wide }) => $wide ? "1 / -1" : "auto"};
`;

export const ModalFormLabel = styled.label`
  display: block;
  font-size: 12px;
  font-family: rebondG-Semi-Bold;
  color: #4a5568;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
`;

export const ModalOptionalText = styled.span`
  color: #8491a8;
  font-family: rebondG-Regular;
  font-size: 11px;
  margin-left: 6px;

  &::before {
    content: "(";
  }

  &::after {
    content: ")";
  }
`;

export const ModalGroupHeader = styled.div`
  grid-column: 1 / -1;
  background: linear-gradient(135deg, rgba(47, 103, 216, 0.08), rgba(47, 103, 216, 0.03));
  border: 1px solid rgba(47, 103, 216, 0.14);
  border-radius: 12px;
  padding: 11px 14px;
  margin-top: 2px;

  strong,
  span {
    display: block;
  }

  strong {
    color: #1a3568;
    font-family: rebondG-Semi-Bold;
    font-size: 13px;
    margin-bottom: 2px;
  }

  span {
    color: #6b7a99;
    font-size: 12px;
    line-height: 1.45;
  }
`;

export const ModalFormInput = styled.input`
  width: 100%;
  height: 44px;
  border: 1.5px solid #e0e6f4;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 14px;
  color: #191919;
  background: #fafbfd;
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: #2f67d8;
    background: #fff;
  }

  &::placeholder {
    color: #9da9bc !important;
    font-family: rebondBook, sans-serif !important;
    font-weight: 400 !important;
    opacity: 0.82;
  }

  &[type='date'] {
    padding: 0 12px;
    color: #191919;
  }
`;

export const ModalFormError = styled.p`
  font-size: 13px;
  color: #c0392b;
  background: rgba(192, 57, 43, 0.07);
  border: 1px solid rgba(192, 57, 43, 0.18);
  border-radius: 8px;
  padding: 10px 14px;
  margin: 0 0 16px;
  line-height: 1.5;
`;

export const ModalSubmitBtn = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #1a3568 0%, #2f67d8 100%);
  color: #fff;
  font-size: 14px;
  font-family: rebondG-Semi-Bold;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(47, 103, 216, 0.3);
  transition: all 0.18s ease;

  &:hover:not(:disabled) {
    box-shadow: 0 6px 16px rgba(47, 103, 216, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 64px 20px;
  color: #6b7a99;

  h6 {
    font-size: 16px;
    color: #191919;
    font-family: rebondG-Semi-Bold;
    margin: 16px 0 6px;
  }

  p {
    font-size: 13px;
    color: #6b7a99;
    margin: 0;
  }
`;
